import { useSelector } from 'react-redux';

import { showCancellationNoticeSelector } from 'redux/modules/pricing/selectors';

export default function usePlanCancelledModal() {
  return useSelector(showCancellationNoticeSelector);
}
